import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { useMemo } from 'react';
import { composeRenderProps } from 'react-aria-components';
import AriaPopover from './aria/popover.esm.js';
import { popoverStyles } from './popover.styles.esm.js';

var _excluded = ["className", "children", "color", "radius", "marginY"];
/**
 * Core wrapper component for Popover, only contains cosmos-based styling. Extend/compose this component for different uses cases
 * - Info Tooltip,
 * - Dropdown list
 */
var PopoverCore = function PopoverCore(props) {
  var _props$className = props.className,
    _className = _props$className === void 0 ? '' : _props$className,
    children = props.children,
    _props$color = props.color,
    color = _props$color === void 0 ? 'base' : _props$color,
    radius = props.radius,
    marginY = props.marginY,
    rest = _objectWithoutProperties(props, _excluded);
  var classes = useMemo(function () {
    return composeRenderProps(_className, function (className, renderProps) {
      var classes = popoverStyles(_objectSpread2(_objectSpread2({}, renderProps), {}, {
        className: className,
        color: color,
        marginY: marginY,
        radius: radius
      }));
      return "csg-tw-popover ".concat(classes, " ");
    });
  }, [color, radius, _className, marginY]);
  return (
    /*#__PURE__*/
    /**
     * Keep className at the end to prevent un-intentional override.
     */
    React__default.createElement(AriaPopover, _extends({}, rest, {
      className: classes
    }), children)
  );
};

export { PopoverCore };
//# sourceMappingURL=popover-core.esm.js.map
